import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { pure } from '@dbk/ui-react-utils';

import { HorizontalDashes } from '../../../components/common/dashes';
import { SEPARATOR_STROKE } from '../../../constants';
import styles from './transaction-details.styles';
import Text from '@dbk/ui-text'

function TransactionDetailsDescription(props) {
  const { description, maxChars ,messages} = props;

  if (description && description.length > maxChars) {
    return (
      <View style={styles.rootDescription}>
        <Text type="secondary">{description}</Text>
      </View>
    );
  }

  return null;
}

TransactionDetailsDescription.propTypes = {
  description: PropTypes.string,
  maxChars: PropTypes.number,
};

TransactionDetailsDescription.defaultProps = {
  maxChars: 30,
};

export default pure(TransactionDetailsDescription);
